var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBatteries = function SvgBatteries(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "inherit",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M6.117 4.225A.78.78 0 0 1 6.667 4h2.666c.207 0 .404.081.55.225s.228.34.228.544v.77h3.778v-.77c0-.204.082-.4.228-.544a.78.78 0 0 1 .55-.225h2.666c.207 0 .405.081.55.225s.228.34.228.544v.77h2.333c.413 0 .809.162 1.1.45S22 6.67 22 7.077v11.385c0 .408-.164.799-.456 1.087-.291.289-.687.451-1.1.451H3.556c-.413 0-.809-.162-1.1-.45A1.53 1.53 0 0 1 2 18.461V7.077c0-.408.164-.8.456-1.088.291-.288.687-.45 1.1-.45h2.333v-.77c0-.204.082-.4.228-.544"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "inherit",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M12.842 9 10 12.84h3.717l-2.028 3.652"
  })));
};
export default SvgBatteries;